import { render, staticRenderFns } from "./TwitterSelectProfileType.vue?vue&type=template&id=2153a168&scoped=true"
import script from "./TwitterSelectProfileType.vue?vue&type=script&lang=js"
export * from "./TwitterSelectProfileType.vue?vue&type=script&lang=js"
import style0 from "./TwitterSelectProfileType.vue?vue&type=style&index=0&id=2153a168&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2153a168",
  null
  
)

export default component.exports